import cn from './cn.js';

export default function Spinner({ className = 'h-4 w-4', label = 'Loading' }) {
  return (
    <svg
      className={cn('animate-spin shrink-0', className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      role="status"
      aria-label={label}
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-80"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}

export function PageSpinner({ className, label = 'Loading' }) {
  return (
    <div className={cn('flex h-full min-h-[40vh] w-full items-center justify-center', className)}>
      <Spinner className="h-7 w-7 text-indigo-600" label={label} />
    </div>
  );
}
